import React, { useState, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import {
    Button,
    Form,
    Segment,
    Header,
    Container,
    Checkbox,
    Icon,
    Dropdown,
    Modal,
    Grid,
    Divider,
    List,
} from 'semantic-ui-react'
import moment from "moment";

import translations from "../../utils/translations";

const AssistanceModal = (props) => {
  const {
    openAssistanceModal,
    setOpenAssistanceModal,
  } = props;

  return (
    <Modal
      closeIcon
      basic
      centered={true}
      onClose={() => setOpenAssistanceModal(false)}
      onOpen={() => setOpenAssistanceModal(true)}
      open={openAssistanceModal}
      size="large"
    >
      <Modal.Content content>
        <Segment inverted style={{ height: "100%" }}>
          <Grid stackable divided inverted>
            <Grid.Row columns={2}>
              <Grid.Column width={6} verticalAlign="middle" textAlign="center">
                <Header inverted content="© Ruf 2025" />
              </Grid.Column>
              {/*<Grid.Column width={6}>
									<Header inverted content="Información Desarrolladores" />
									<Divider></Divider>
									<List divided>
										<List.Item
											icon="github"
											content="Adán Contreras"
											style={{ cursor: 'pointer' }}
											onClick={() => {
												window.open('https://github.com/Acaryes', '_blank')
											}}
										/>
										<List.Item
											icon="github"
											content="Samuel Gutierrez"
											style={{ cursor: 'pointer' }}
											onClick={() => {
												window.open('https://github.com/SamuelCosmo', '_blank')
											}}
										/>
										<List.Item
											icon="github"
											content="German Mariles"
											style={{ cursor: 'pointer' }}
											onClick={() => {
												window.open('https://github.com/MarilesBeard5', '_blank')
											}}
										/>
										<List.Item
											icon="github"
											content="Julio Ojeda"
											style={{ cursor: 'pointer' }}
											onClick={() => {
												window.open('https://github.com/Jucesr', '_blank')
											}}
										/>
										<List.Item
											icon="github"
											content="Javier Rangel"
											style={{ cursor: 'pointer' }}
											onClick={() => {
												window.open('https://github.com/xavyrangel', '_blank')
											}}
										/>
									</List>
                              </Grid.Column>*/}
              <Grid.Column width={8}>
                <Header inverted content="Contacto" />
                <Divider></Divider>
                <Header
                  size="small"
                  inverted
                  content="¿Necesitas registrar un nuevo ticket o solicitud?"
                />
                <List divided inverted>
                  {/* <List.Item
											header='Ingresa al Portal: '
											content='https://geologistic.com.mx/Soporte/'
											style={{ cursor: 'pointer' }}
											onClick={() => {
												window.open(
													'https://geologistic.com.mx/Soporte/',
													'_blank'
												)
											}}
										/> */}
                  <List.Item
                    header="Soporte"
                    content="(686) 214 5447, (686) 385 6938,  (686) 510 9915"
                  />
                  <List.Item header="Oficina" content="(686) 372 9877" />
                  <List.Item
                    header="Emergencias"
                    content="(686) 420 3333, (686) 214 5447, (686) 385 6938, (686) 510 9915,  (686) 123 6454"
                  />
                  <List.Item header="Administración" content="(686) 122 0316" />
                  <List.Item
                    header="Ventas"
                    content="(686) 510 9915, (686) 196 4736, (686) 420 8586,  (686) 191 1571"
                  />
                </List>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
      </Modal.Content>
    </Modal>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setOpenAssistanceModal: (payload) => dispatch({type: 'SET_ASSISTANCE_MODAL', payload})
});

const mapStateToProps = (state) => ({
  openAssistanceModal: state?.clientNavigation?.openAssistanceModal,
  currentTranslations: translations[state.app.lang],
});

export default connect(mapStateToProps, mapDispatchToProps)(AssistanceModal);
